import { useSelector } from "react-redux";
import {
  selectAllPropPresets,
  selectSelectedElement,
  selectSelectedElementId,
  selectTakes3D,
  setSelectedInteraction,
  setSelectedTake,
  replaceTakesFromUnity,
} from "../../app/slices/TrainingSlice";
import { InteractionType } from "../../models/interactions/Interaction";
import { PropMetadata } from "../../dto/PropMetadata";
import {
  IDynamicInteraction,
  IDynamicInteractionProperty,
} from "../../models/interactions/DynamicInteraction";
import { useCallback } from "react";
import { RootState } from "../../app/Store";

export default function useAutoReImportDynamicInteractions() {
  const props = useSelector(selectAllPropPresets);
  const all3DTakes = useSelector(selectTakes3D);

  const reImportDynamicInteractions = useCallback(
    (propmetadata: PropMetadata, dispatch: any, getState: () => RootState) => {
      // fresh data instead of snapshot
      const all3DTakes = selectTakes3D(getState());
      const props = selectAllPropPresets(getState());
      const selectedElement = selectSelectedElement(getState());

      const takes = structuredClone(all3DTakes);
      const affectedProps = props.filter((p) => p.propId === propmetadata.id);

      let isTake = false;
      for (let i = 0; i < takes.length; i++) {
        if (takes[i].id === selectedElement?.id) {
          isTake = true;
        }
        for (let j = 0; j < takes[i].interactions.length; j++) {
          if (
            takes[i].interactions[j].type === InteractionType.DynamicInteraction
          ) {
            var cast = takes[i].interactions[j] as IDynamicInteraction;
            if (affectedProps.some((p) => p.id === cast.source)) {
              takes[i].interactions[j] = updateDynamicInteraction(
                cast,
                propmetadata
              );
            }
          }
        }
      }

      dispatch(replaceTakesFromUnity(takes));

      // set takes causes a refresh, so we set selected element back to what it was
      if (selectedElement) {
        if (isTake) dispatch(setSelectedTake(selectedElement.id));
        else dispatch(setSelectedInteraction(selectedElement.id));
      }
    },
    []
  );

  // I should actually also do this when loading the training !
  const updateDynamicInteraction = (
    interaction: IDynamicInteraction,
    propmetadata: PropMetadata
  ) => {
    // [x] check for differences between dynamic interaction in take and dynamic interaction in propmetadata
    // [x] remove the properties that are not in the propmetadata
    // [x] add the properties that are in the propmetadata
    // [x] change the types that are different

    // sketchy
    const dynamicInteraction = propmetadata.dynamicInteractions?.find(
      (d) => d.title === interaction.name
    );

    if (!dynamicInteraction) return interaction;

    const copy = structuredClone(interaction);

    // update tag ?
    copy.interactionTag = dynamicInteraction.interactionTag;

    // add or update properties
    for (let i = 0; i < dynamicInteraction.properties.length; i++) {
      const property = dynamicInteraction.properties[i];
      const interactionPropertyIndex =
        interaction.dynamicInteractionProperties.findIndex(
          (p) => p.id === property.id
        );

      if (interactionPropertyIndex === -1) {
        copy.dynamicInteractionProperties.push(property);
      } else {
        var interactionProperty = structuredClone(
          interaction.dynamicInteractionProperties[interactionPropertyIndex]
        );

        // type is different
        if (interactionProperty.type !== property.type) {
          interactionProperty.type = property.type;
          interactionProperty.value = property.value || "";
        }

        // update values, name, description, requiredTag
        interactionProperty = {
          ...interactionProperty,
          values: property.values || [],
          name: property.name,
          description: property.description,
          requiredTag: property.requiredTag,
        };

        copy.dynamicInteractionProperties[interactionPropertyIndex] =
          interactionProperty;
      }
    }

    // remove properties that are not in the propmetadata
    for (let i = 0; i < interaction.dynamicInteractionProperties.length; i++) {
      const interactionProperty = interaction.dynamicInteractionProperties[i];
      if (
        !dynamicInteraction.properties.some(
          (p) => p.id === interactionProperty.id
        )
      ) {
        copy.dynamicInteractionProperties.splice(i, 1);
      }
    }

    return copy;
  };

  return { reImportDynamicInteractions };
}
